export function isLinkExternal(url) {
    if (url.charAt(0) === '/') {
        return false;
    }
    let transformedUrl = url.replace(/^https?:\/\//, '');
    let min = transformedUrl.length;
    const urlChars = ['/', '?', '#', ':'];
    urlChars.forEach((ch) => {
        const idx = transformedUrl.indexOf(ch);
        if (idx !== -1) {
            min = Math.min(min, idx);
        }
    });
    transformedUrl = transformedUrl.substring(0, min);
    return !['aws.amazon.com', 'aws.com'].includes(transformedUrl);
}
